/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import api from '~/services/api';
import history from '~/services/history';
import { Container, Row, Header, ButtonTest } from './styles';

export default function Tutoria() {
  const [users, setUsers] = useState([]);
  // const [feedback, setFeedback] = useState('');

  useEffect(() => {
    async function getDataStudents() {
      const { data } = await api.get('/users');
      setUsers(data);
    }

    getDataStudents();
  }, []);

  return (
    <>
      <Header>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorChallenge')}
        >
          <h2>Desafios</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/educatorJobs')}>
          <h2>Vagas</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorTutoria')}
        >
          <h2>Tutoria</h2>
        </ButtonTest>
        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/educatorUsers')}
        >
          <h2>Usuários</h2>
        </ButtonTest>
      </Header>
      <Container>
        <h2>Lista de Usuarios ({users.length}):</h2>
        {users.map(user => (
          <Link key={user.id} to={`userprofile/${user.id}`}>
            <Row>
              <p>ID: {user.id}</p>
              <p>
                Aluno: {user.first_name} {user.last_name}
              </p>
              <p>Email: {user.email}</p>
              <p>Nivel de Programaçāo: {user.level}</p>
              <p>Nivel de Inglês: {user.english}</p>
              <p>Entrou na plataforma: {user.created_at}</p>
            </Row>
          </Link>
        ))}
      </Container>
    </>
  );
}
